import { render, staticRenderFns } from "./ArticleDomainList.vue?vue&type=template&id=113161d0&scoped=true&"
import script from "./ArticleDomainList.vue?vue&type=script&lang=js&"
export * from "./ArticleDomainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113161d0",
  null
  
)

export default component.exports